var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommunicationCentre(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "64px",
    height: "55px",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 64 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Plan_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: 64,
    height: 55
  }), /*#__PURE__*/React.createElement("g", {
    id: "_1330949907200"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1E4887",
    strokeWidth: 1,
    strokeMiterlimit: 22.9256,
    cx: 32,
    cy: 30,
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1E4887",
    strokeWidth: 1,
    strokeMiterlimit: 22.9256,
    d: "M32 21c3,0 6,1 8,4 -2,1 -5,2 -8,2 -3,0 -6,-1 -8,-2 2,-2 5,-4 8,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1E4887",
    strokeWidth: 1,
    strokeMiterlimit: 22.9256,
    d: "M40 36c-2,2 -5,4 -8,4 -3,0 -6,-1 -8,-4 2,-1 5,-2 8,-2 3,0 6,1 8,2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "none",
    stroke: "#1E4887",
    strokeWidth: 1,
    strokeMiterlimit: 22.9256,
    cx: 32,
    cy: 30,
    rx: 4,
    ry: 10
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1E4887",
    strokeWidth: 1,
    strokeMiterlimit: 22.9256,
    x1: 32,
    y1: 21,
    x2: 32,
    y2: 40
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1E4887",
    strokeWidth: 1,
    strokeMiterlimit: 22.9256,
    x1: 42,
    y1: 30,
    x2: 22,
    y2: 30
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1E4887",
    strokeWidth: 1,
    strokeMiterlimit: 22.9256,
    d: "M53 1c13,12 -12,12 0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1E4887",
    strokeWidth: 1,
    strokeMiterlimit: 22.9256,
    d: "M53 21c1,-4 -3,-8 -7,-9 -1,6 2,8 7,9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1E4887",
    strokeWidth: 1,
    strokeMiterlimit: 22.9256,
    d: "M54 21c-1,-4 3,-8 7,-9 1,6 -2,8 -7,9z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1E4887",
    strokeWidth: 1,
    strokeMiterlimit: 22.9256,
    x1: 53,
    y1: 10,
    x2: 53,
    y2: 21
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1E4887",
    strokeWidth: 1,
    strokeMiterlimit: 22.9256,
    cx: 12,
    cy: 41,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1E4887",
    strokeWidth: 1,
    strokeMiterlimit: 22.9256,
    d: "M12 45l0 0c4,0 8,3 8,8l0 1 -15 0 0 -1c0,-4 3,-8 8,-8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1E4887",
    strokeWidth: 1,
    strokeMiterlimit: 22.9256,
    d: "M6 7l14 0c0,0 1,0 1,1l0 8 -15 0 0 -8c0,0 0,-1 1,-1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1E4887",
    strokeWidth: 1,
    strokeMiterlimit: 22.9256,
    points: "3,16 22,16 21,19 4,19 "
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    stroke: "#1E4887",
    strokeWidth: 1,
    strokeMiterlimit: 22.9256,
    x: 8,
    y: 10,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    stroke: "#1E4887",
    strokeWidth: 1,
    strokeMiterlimit: 22.9256,
    x: 12,
    y: 10,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    stroke: "#1E4887",
    strokeWidth: 1,
    strokeMiterlimit: 22.9256,
    x: 15,
    y: 10,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1E4887",
    strokeWidth: 1,
    strokeMiterlimit: 22.9256,
    d: "M43 43l17 0c0,0 1,0 1,1l0 10 -18 0 0 -10c0,0 0,-1 1,-1z"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1E4887",
    strokeWidth: 1,
    strokeMiterlimit: 22.9256,
    points: "43,44 51,48 60,44 "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1E4887",
    strokeWidth: 2,
    strokeMiterlimit: 22.9256,
    d: "M22 9c7,-3 13,-3 20,0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1E4887",
    strokeWidth: 2,
    strokeMiterlimit: 22.9256,
    d: "M55 24c2,6 1,11 -2,17"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1E4887",
    strokeWidth: 2,
    strokeMiterlimit: 22.9256,
    d: "M9 33c-1,-4 0,-8 2,-12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1E4887",
    strokeWidth: 2,
    strokeMiterlimit: 22.9256,
    d: "M40 51c-6,2 -11,2 -17,-1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#8DC63F",
    strokeWidth: 1,
    strokeMiterlimit: 22.9256,
    d: "M53 21c1,-4 -3,-8 -7,-9 -1,6 2,8 7,9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#8DC63F",
    strokeWidth: 1,
    strokeMiterlimit: 22.9256,
    d: "M54 21c-1,-4 3,-8 7,-9 1,6 -2,8 -7,9z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4FB847",
    strokeWidth: 1,
    strokeMiterlimit: 22.9256,
    x1: 53,
    y1: 10,
    x2: 53,
    y2: 21
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "red",
    strokeWidth: 1,
    strokeMiterlimit: 22.9256,
    d: "M53 1c13,12 -12,12 0,0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#8DC63F",
    strokeWidth: 1,
    strokeMiterlimit: 22.9256,
    d: "M53 21c1,-4 -3,-8 -7,-9 -1,6 2,8 7,9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#8DC63F",
    strokeWidth: 1,
    strokeMiterlimit: 22.9256,
    d: "M54 21c-1,-4 3,-8 7,-9 1,6 -2,8 -7,9z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4FB847",
    strokeWidth: 1,
    strokeMiterlimit: 22.9256,
    x1: 53,
    y1: 10,
    x2: 53,
    y2: 21
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "red",
    strokeWidth: 1,
    strokeMiterlimit: 22.9256,
    d: "M53 1c13,12 -12,12 0,0z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunicationCentre);
export default __webpack_public_path__ + "static/media/communicationCentre.0e1add8ca4a04ed4d6ab00f7d392260e.svg";
export { ForwardRef as ReactComponent };